export default "__VITE_ASSET__CMaKhwoA__"